import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import Form from '../elements/Form'
import StaticInput from '../elements/forms/StaticInput'
import PasswordInput from '../elements/forms/PasswordInput'
import Dismissible from '../elements/Dismissible'
import AppUtils from '../../utils/AppUtils'

class PasswordForm extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      input: {
        password: ''
      },
      isValid: true,
      error: null
    }

    // Bind events
    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    // Register submit event
    if (_.isFunction(this.props.registerSubmit)) {
      this.props.registerSubmit(this.onSubmit)
    }
  }

  onChange(password, isValid) {
    this.setState(_.extend(
      {
        isValid
      },
      isValid
        ? {
            input: {
              password
            }
          }
        : {}
    ))
  }

  onSubmit() {
    if (this.state.isValid) {
      this.props.onSubmit(this.state.input)
    }
    else {
      this.setState({
        error: 'Les deux mots de passe ne correspondent pas.'
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.error
            ? <Dismissible
                header={AppUtils.errorToTitle(this.props.error)}
                content={AppUtils.errorToText(this.props.error)}
                color='red'
                onDismiss={this.props.onClearError}
              />
            : null
        }
        {
          this.state.error
            ? <Dismissible
                content={this.state.error}
                color='orange'
                onDismiss={() => { this.setState({ error: null })}}
              />
            : null
        }
        <Form
          onSubmit={this.onSubmit}
          loading={this.props.isSaving}
        >
          <StaticInput
            label='Nom et prénom'
            content={this.props.username}
          />
          <PasswordInput
            label1='Nouveau'
            label2='Répétez'
            value={this.state.input.password}
            onChange={this.onChange}
          />
        </Form>
      </React.Fragment>
    )
  }
}

PasswordForm.propTypes = {
  username: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  registerSubmit: PropTypes.func,
  error: PropTypes.object
}

export default PasswordForm



// WEBPACK FOOTER //
// ./src/components/forms/PasswordForm.js